import axios from "@/lib/axios";

const getFacility = () => {
  return axios.get("/facility/sessions");
}

export default getFacility;
